import { render } from "./TheStore.vue?vue&type=template&id=d6b0dacc"
import script from "./TheStore.vue?vue&type=script&lang=js"
export * from "./TheStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__